import { format } from '@if/core/date'
import { BodyText, Caption, MetaValue, useDialog } from '@if/mui'
import { Box, Divider, Stack } from '@mui/material'
import { InteracPossibleMatch } from '@src/types/interac'
import { StickyNote } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const useInteracCandidateNotesDialog = () => {
  const { t } = useTranslation()

  return useDialog<InteracPossibleMatch>({
    icon: StickyNote,
    title: t('interacWire.notes'),
    subtitle: (ctx) => `${ctx.props.applicantFirstName} ${ctx.props.applicantLastName}`,
    edgeToEdge: true,
    hideConfirm: true,
    maxWidth: 'sm',
    fullWidth: true,
    content: (ctx) => (
      <Box>
        {ctx.props.notes.map((note, index) => (
          <Box key={`${note.createdOn}-${index}`}>
            {index > 0 && <Divider />}
            <Stack spacing={0.5} sx={{ px: 3, py: 2 }}>
              <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
                <MetaValue>{note.createdByUsername}</MetaValue>
                <Caption>{format(note.createdOn, 'P')}</Caption>
              </Stack>
              <BodyText>{note.note}</BodyText>
            </Stack>
          </Box>
        ))}
      </Box>
    ),
  })
}
